<template>
  <div class="container help">
    <ul>
      <li class="list_item">
        <router-link :to="{ path: '/support?id=1' }">
          <p class="txt">福利领取</p>
          <i class="arrow_right"></i>
        </router-link>
      </li>
      <li class="list_item">
        <router-link :to="{ path: '/support?id=2' }">
          <p class="txt">订单发货</p>
          <i class="arrow_right"></i>
        </router-link>
      </li>
      <li class="list_item">
        <router-link :to="{ path: '/support?id=3' }">
          <p class="txt">售后服务</p>
          <i class="arrow_right"></i>
        </router-link>
      </li>
      <!-- <li class="list_item">
        <a href="http://www.sobot.com/chat/h5/index.html?sysNum=992f16526a574adabc07e3e4f666478b">
          <p class="txt">在线客服</p>
          <i class="arrow_right"></i>
        </a>
      </li> --> 
    </ul>
    <div class="marks">
      <p class="mark">如需帮助</p>
      <p class="mark">请联系公司HR或拨打平台热线400-051-1302</p>
    </div>
    <home :ishome=0></home>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import home from '../common/home.vue'
  export default {
    data() {
      return {}
    },
    components: {
      home
      },
    computed: {
      ...mapGetters({}),

    },
    watch: {},
    created() {

    },
    methods: {},
    mounted() {
    }
  }
</script>
<style>
.marks {
  margin-top: 1rem;
}
.mark {
  color: #B6B6B7;
  text-align: center;
  display: block;
  font-size: 0.38rem;
  line-height: 0.8rem;
}
</style>